export default "__VITE_ASSET__CADADjxc__"